'use strict';
import recommendations from './product/recommendations';



// re-initialize Einstein Recommendation carousel
function screenResizeHandler() {
    // Store the window width
    var winWidth = $(window).width();
    $(window).on('resize orientationchange', function () {
        // to prevent calling of resize event in IOS devices while scrolling
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
            // Do stuff here
            var $recommendationCarousel = $('.recommendation-container .carousel-recommendations');			
            if ($recommendationCarousel.hasClass('slick-initialized')) {
                $recommendationCarousel.slick('destroy');
                recommendations.init();
                $('.carousel-recommendations select').selectmenu();
            }
        }
    });
}

var pageNotFoundError = {
    /**
     * @function
     * @description method to init search404Page
     */

    init: function () {

        var $form = $('.page-not-found-404 .search-form-wrapper form[name=\'simpleSearchPgNotFound\']'),
            $searchField = $form.find('.search-text'),
            $cancelButton = $form.find('.cancel-btn'),
            $submitButton = $form.find('.search-btn');
        //hide clear button on load event 
        $cancelButton.hide();
        $submitButton.prop('disabled', true);
        $searchField.val('');

        // on key up listener
        $searchField.on('keyup', function (e) {
            // get display clear button on type
            if ($searchField.val().trim().length > 0) {
                $cancelButton.show();
                $submitButton.prop('disabled', false);
            } else {
                $cancelButton.hide();
                $submitButton.prop('disabled', true);
            }

        }.bind(this));  
        
        // cancel button hide
        $cancelButton.on('click', function (e) {
            $cancelButton.hide();
            $submitButton.prop('disabled', true);
        }.bind(this));

        setTimeout(function() {
            recommendations.init();
            $('.carousel-recommendations select').selectmenu();
        }, 5000);
        screenResizeHandler();
    }

};

export default pageNotFoundError;
